import { useInstantSearch } from 'react-instantsearch';

import { useResetFiltersOnSamePageNavigation } from '#src/app/pages/search/shared/hooks';

export const ResetFiltersOnSamePageNavigation: React.FC = () => {
	const { setIndexUiState } = useInstantSearch();

	useResetFiltersOnSamePageNavigation({
		resetFilters: () => {
			setIndexUiState({});
		},
	});

	return null;
};
